export default function CheckNoBg({
  size = 16,
  className,
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M5 7.5L7.33333 10L12 5"
        stroke="#04111B"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  )
}
